// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    arkosePublicKey: 'B7CA90B6-9F8A-42EC-BD11-3EE9E6CDE171',
    companyId: 21,
    appDevFlag: false,
    enableUTF: true,
    responderProgramid: '5dc9bf411b0f42229c31d6ab',
    miltaryProgramid: '5dc9bf1ad9c31a2309710a0c',
    medicalProgramid: '5dc9bf60ad801f220421ab04',
    employeeProgramid: '5ed6a0829478771a7f155bc0',
    volunteerEntilementid: 187,
    fnEntitlementid: 21,
    // Below url is to redirect sub paid meber/sub paid mem+ admin to premier dashboard
    premierDashboard: 'https://e-tst3.stage.att.com/msapi/login/unauth/service/v1/haloc/do/login?host=e-tst3.stage.att.com&state=from=idp&client_id=m36147&is_passive=true&final_url=https%3A%2F%2Fe-tst3.stage.att.com%2Fbuy%2Fphones',
    changePlan: 'https://test3.att.com/acctmgmt/passthrough/fnconversionlander',
    enableAPICall: true,
    loginURL: 'https://test-localcontrol.firstnet.att.com/admin',
    pilot: false,
    enableSessionTimeout: true,
    enableUTFSessionTimeout: true,
    hideRegistrationPage: false,
    authId: '7895322494269548',
    plp_page: 'https://test3.att.com/msapi/login/unauth/service/v1/haloc/do/login?host=test3.att.com&state=from=idp&client_id=m36147&is_passive=true&final_url=https%3A%2F%2Ftest3.att.com%2Fbuy%2Fphones',
    att_Utf_Path: 'https://www.att.com/',
    att_auth_domain: 'https://test2-utf-www.firstnet.com/',
    signup_domain: 'https://test2-www.firstnet.com/signup/',
    utf_domain: 'https://test2-www.firstnet.com',
    pilot_domain: 'https://test2-pilot-www.firstnet.com',
    att_logout: 'https://signin.stage.clogin.att.com/dynamic/iamLRR/LrrController?IAM_OP=logout&appName=m03634&returnURL=',
    fn_logout: 'https://fcontent.stage.att.com/dynamic/iamLRR/LrrController?IAM_OP=logout&returnURL=',
    fn_SessionUrl: 'https://oidc.stage.flogin.att.com/mga/sps/authsvc?PolicyId=urn:ibm:security:authentication:asf:tokenauthenticator&IAM_OP=UTFRegistration&fToken=',
    //learnMore link
    learnMore: 'https://www.firstnet.com/signup/learnMore',
    getBrowserPath: () => {
        let url = 'https://test2-www.firstnet.com/signup/';
        return url;
    },
    getApiLiveUrl: () => {
        let url = '';
        if (window.location.hostname === 'test2-www.firstnet.com') {
            url = 'https://test2-www.firstnet.com/ilm_fntest2/';
        } else {
            url = 'https://fnicamqa2.stage.att.com/ilm_fntest2/';
        }
        return url;
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
